"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignEmployee = assignEmployee;
exports.create = create;
exports.exportEmployees = exportEmployees;
exports.getActiveTeams = getActiveTeams;
exports.getAllEmployees = getAllEmployees;
exports.getTeamMembers = getTeamMembers;
exports.getTeams = getTeams;
exports.getUnassignedAccountManagers = getUnassignedAccountManagers;
exports.removeEmployee = removeEmployee;
exports.removeTeam = removeTeam;
exports.update = update;
exports.updateEmployeeTargetMargin = updateEmployeeTargetMargin;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getAllEmployees(year, month) {
  return _api["default"].get("/api/team/employees/".concat(year, "/").concat(month)).then(_api.extractData)["catch"](_api.errorHandler);
}

function exportEmployees(year, month) {
  return _api["default"].get("/api/team/employees/".concat(year, "/").concat(month, "/export")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getTeams() {
  return _api["default"].get("/api/team").then(_api.extractData)["catch"](_api.errorHandler);
}

function getActiveTeams() {
  return _api["default"].get("/api/team/active").then(_api.extractData)["catch"](_api.errorHandler);
}

function getTeamMembers() {
  return _api["default"].get("/api/team/members").then(_api.extractData)["catch"](_api.errorHandler);
}

function create(data) {
  return _api["default"].post('/api/team', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(id, data) {
  return _api["default"].post('/api/team/' + id, data).then(_api.extractData)["catch"](_api.errorHandler);
}

function assignEmployee(data) {
  return _api["default"].post('/api/team/assign-employee', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function removeEmployee(data) {
  return _api["default"].post('/api/team/remove-employee', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function removeTeam(id, year, month) {
  return _api["default"]["delete"]("/api/team/".concat(id, "/").concat(year, "/").concat(month)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getUnassignedAccountManagers(year, month) {
  return _api["default"].get("/api/team/unassigned-account-managers/".concat(year, "/").concat(month)).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateEmployeeTargetMargin(_ref) {
  var effectiveDate = _ref.effectiveDate,
      employeeId = _ref.employeeId,
      targetMargin = _ref.targetMargin;
  return _api["default"].post('/api/team/target-margin', {
    effectiveDate: effectiveDate,
    employeeId: employeeId,
    targetMargin: targetMargin
  }).then(_api.extractData)["catch"](_api.errorHandler);
}